import md5 from 'md5';
import wx from 'weixin-js-sdk';
import sha1 from 'js-sha1';
let commonJs = {
    lastTime: function (data) {
        var day = Math.floor(data / (1000 * 60 * 60 * 24));
        var time = '',
            min = '',
            seconds = '',
            lastTime = '';
        if (day >= 1) { //大于1天
            time = Math.floor((data - (day * 1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            min = Math.floor((data - (time * 1000 * 60 * 60) - (day * 1000 * 60 * 60 * 24)) / (1000 * 60));
            seconds = Math.floor((data - (min * 1000 * 60) - (time * 1000 * 60 * 60) - (day * 1000 * 60 * 60 * 24)) / (1000));
            lastTime = day + '天' + time + '小时' + min + '分钟' + seconds + '秒';
        } else { //无天数
            time = Math.floor(data / (1000 * 60 * 60));
            if (time >= 1) { //大于1小时
                min = Math.floor((data - (time * 1000 * 60 * 60)) / (1000 * 60));
                seconds = Math.floor((data - (min * 1000 * 60) - (time * 1000 * 60 * 60)) / (1000));
                lastTime = time + ':' + min  + ':' + seconds ;
            } else { //0小时
                min = Math.floor(data / (1000 * 60));
                if (min >= 1) { //大于1分钟
                    seconds = Math.floor((data - (min * 1000 * 60)) / (1000));
                    if(seconds<10){
                        seconds = '0' + seconds;
                    }
                    lastTime = min + ':' + seconds ;
                } else { //小于一分钟
                    seconds = Math.floor(data / 1000);
                    if (seconds >= 1) {
                        lastTime = seconds ;
                    } else {
                        lastTime = false;
                    }

                }
            }
        }
        return lastTime;
    },
    // 随机字符传生成
    randomString: (minPlaces, maxPlaces) => {
        let str = '';
        const arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
        let num = Math.floor(Math.random() * (maxPlaces - minPlaces + 1)) + minPlaces;
        while (num !== 0) {
            str += arr[Math.floor(Math.random() * arr.length)];
            num--;
        }
        return str;
    },
    pay: (authObj, successUrl, failUrl) => {
        // console.log(wxAuthId);
        // const timestamp = parseInt((new Date().getTime() / 1000).toString(), 10);
        // const req = {
        //     appId: 'wxe4dbb7e81d0db4aa', // 公众号名称，由商户传入
        //     timeStamp: timestamp.toString(), // 时间戳，自1970年以来的秒数
        //     nonceStr: str, // 随机串
        //     package: '',
        //     signType: 'MD5', // 微信签名方式：
        // };
        // req['package'] = 'prepay_id=' + wxAuthId;
        // const keynamearr = Object.keys(req);
        // keynamearr.sort();
        // const arr = [];
        // for (const key of keynamearr) {
        //     arr.push(key + '=' + req[key]);
        // }

        function clearurl() {
            const reqarr = window.location.search.split('?')[0].split('&');
            const newarr = [];
            reqarr.map((item) => {
                if (item.split('=')[0] !== 'wxAuthId') {
                    newarr.push(item);
                }
            });
            window.history.replaceState({}, '', '?' + newarr.join('&'));
        }
        // console.log(md5(arr.join('&') + '&key=VbuFRbvZm7bZZMxNVpxpUFw7SID9DJWK').toUpperCase(),11111);
        // window.alert(authObj.appId+'-'+authObj.timestamp+'-'+authObj.nonceStr+'-'+authObj.signature+'-'+authObj.signType+'-'+authObj.package);
        // return;
        wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: authObj.appId, // 必填，公众号的唯一标识
            timestamp:authObj.timeStamp, // 必填，生成签名的时间戳
            nonceStr: authObj.nonceStr, // 必填，生成签名的随机串
            signature: authObj.signature, // 必填，签名
            jsApiList: ['getBrandWCPayRequest', 'chooseWXPay'], // 必填，需要使用的JS接口列表
        });
        wx.ready(() => {
            wx.chooseWXPay({
                timestamp:authObj.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: authObj.nonceStr, // 支付签名随机串，不长于 32 位
                package:  authObj.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                signType: authObj.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                paySign:authObj.signature,// 支付签名
                success(res) {
                    clearurl();
                    window.location.href = successUrl;
                },
                fail(err) {
                    clearurl();
                    window.location.href = failUrl;
                },
                cancel(cancel) {

                },
            });
        });
        wx.error((res) => {
            clearurl();
        });
    },
}
export default commonJs;
